import { $enum } from 'ts-enum-util';

export interface IProtoEnumKeysOptions {
	withUnspecified?: boolean;
}

export const protoEnumKeys = <T extends Record<Extract<keyof T, string>, number>>(
	enumObj: T,
	{ withUnspecified = false }: IProtoEnumKeysOptions = {}
): Extract<keyof T, string>[] => {
	const keys = $enum(enumObj).getKeys();
	const filterValue = withUnspecified ? -1 : 0;

	return keys.filter((key) => enumObj[key] > filterValue);
};
